A salary or compensation range for a position.

Salary ranges are used to refine candidate job searches.
While the monetary values in `minimumAmount` and `maximumAmount` are not visible on job ads,
the currency and interval may be displayed alongside the `descriptions` of the remuneration package for clarity.
